/**
 * Situação comercial que o site precisa anunciar ao visitante.
 *
 * O imóvel vendido/alugado continua acessível por link direto — some das
 * listagens, mas quem abre o link salvo vê a página com a tarja. Convivem duas
 * fontes: `commercial_status` (atual) e `status` (legado), e qualquer uma delas
 * basta para marcar o imóvel como indisponível.
 */
export type UnavailableKind = 'sold' | 'rented';

export interface UnavailabilityInfo {
  kind: UnavailableKind;
  /** Texto curto da tarja: "Vendido" / "Alugado". */
  label: string;
  /** Frase do aviso, já pronta para leitura. */
  message: string;
}

interface AvailabilityFields {
  commercial_status?: string | null;
  status?: string | null;
}

const SOLD: UnavailabilityInfo = {
  kind: 'sold',
  label: 'Vendido',
  message: 'Este imóvel já foi vendido e não está mais disponível.',
};

const RENTED: UnavailabilityInfo = {
  kind: 'rented',
  label: 'Alugado',
  message: 'Este imóvel já foi alugado e não está mais disponível.',
};

export const getUnavailability = (
  property?: AvailabilityFields | null
): UnavailabilityInfo | null => {
  if (!property) return null;

  const commercial = (property.commercial_status || '').toLowerCase();
  const legacy = (property.status || '').toLowerCase();

  if (commercial === 'sold' || legacy === 'vendido') return SOLD;
  if (commercial === 'rented' || legacy === 'alugado') return RENTED;
  return null;
};

export const isUnavailable = (property?: AvailabilityFields | null): boolean =>
  getUnavailability(property) !== null;
